/* eslint-disable */

import {
  CommercialePropertyTypes, CasaPropertyTypes, PropertyTypeGroupValues, TerrenoPropertyTypes, GaragePropertyTypes, StanzaPropertyTypes, LettoPropertyTypes, CantinaPropertyTypes, BarcaPropertyTypes,
} from './types';
// !ATTENTION!
// The property value contained in each of these elements is a kebab-case version
// which is the selected one for any future handling by BE.
// In the APP project there's one more PROPERTY_TYPE_GROUPS object with a 'plus-case' version.
// In order to replace its usages, pay attention to query filters.
export const PROPERTY_TYPE_GROUPS = [
  {
    value: PropertyTypeGroupValues.CASA,
    label: 'Casa',
    resultLabel: 'Case',
    propertyTypes: [
      {
        value: CasaPropertyTypes.APPARTAMENTO,
        label: 'Appartamento',
        resultLabel: 'Appartamenti',
        search: 'appartamento',
      },
      {
        value: CasaPropertyTypes.ATTICO_MANSARDA,
        label: 'Attico/Mansarda',
        resultLabel: 'Attici/mansarde',
        search: 'attico/mansarda',
      },
      {
        value: CasaPropertyTypes.BI_TRIFAMILIARE,
        label: 'Casa Bi/Trifamiliare',
        resultLabel: 'Case bi/trifamiliari',
        search: 'casa bi/trifamiliare',
      },
      {
        value: CasaPropertyTypes.CASA_INDIPENDENTE,
        label: 'Casa indipendente',
        resultLabel: 'Case indipendenti',
        search: 'casa indipendente',
      },
      {
        value: CasaPropertyTypes.LOFT,
        label: 'Loft',
        resultLabel: 'Loft',
        search: 'loft',
      },
      {
        value: CasaPropertyTypes.RUSTICO_CASALE,
        label: 'Rustico/Casale',
        resultLabel: 'Rustici/casali',
        search: 'rustico casale',
      },
      {
        value: CasaPropertyTypes.VILLA,
        label: 'Villa',
        resultLabel: 'Ville',
        search: 'villa',
      },
      {
        value: CasaPropertyTypes.VILLETTA_SCHIERA,
        label: 'Villetta a schiera',
        resultLabel: 'Villette a schiera',
        search: 'villetta a schiera',
      },
      {
        value: CasaPropertyTypes.BAITA_BUNGALOW_CHALET_TRULLO,
        label: 'Baita/Bungalow/Chalet/Trullo',
        resultLabel: 'Baite/bungalow/chalet/trulli',
        search: 'baita/bungalow/chalet/trullo',
      },
      {
        value: CasaPropertyTypes.PALAZZO,
        label: 'Palazzo',
        resultLabel: 'Palazzi',
        search: 'palazzo',
      },
    ],
  },
  {
    value: PropertyTypeGroupValues.NUOVA_COSTRUZIONE,
    label: 'Nuova costruzione',
    resultLabel: 'Nuove costruzioni',
    propertyTypes: [
      {
        value: CasaPropertyTypes.APPARTAMENTO,
        label: 'Appartamento',
        resultLabel: 'Appartamenti',
        search: 'appartamento',
      },
      {
        value: CasaPropertyTypes.ATTICO_MANSARDA,
        label: 'Attico/Mansarda',
        resultLabel: 'Attici/mansarde',
        search: 'attico/mansarda',
      },
      {
        value: CasaPropertyTypes.BI_TRIFAMILIARE,
        label: 'Casa Bi/Trifamiliare',
        resultLabel: 'Case bi/trifamiliari',
        search: 'casa bi/trifamiliare',
      },
      {
        value: CasaPropertyTypes.CASA_INDIPENDENTE,
        label: 'Casa indipendente',
        resultLabel: 'Case indipendenti',
        search: 'casa indipendente',
      },
      {
        value: CasaPropertyTypes.LOFT,
        label: 'Loft',
        resultLabel: 'Loft',
        search: 'loft',
      },
      {
        value: CasaPropertyTypes.RUSTICO_CASALE,
        label: 'Rustico/Casale',
        resultLabel: 'Rustici/casali',
        search: 'rustico casale',
      },
      {
        value: CasaPropertyTypes.VILLA,
        label: 'Villa',
        resultLabel: 'Ville',
        search: 'villa',
      },
      {
        value: CasaPropertyTypes.VILLETTA_SCHIERA,
        label: 'Villetta a schiera',
        resultLabel: 'Villette a schiera',
        search: 'villetta a schiera',
      },
      {
        value: CasaPropertyTypes.BAITA_BUNGALOW_CHALET_TRULLO,
        label: 'Baita/Bungalow/Chalet/Trullo',
        resultLabel: 'Baite/bungalow/chalet/trulli',
        search: 'baita/bungalow/chalet/trullo',
      },
      {
        value: CasaPropertyTypes.PALAZZO,
        label: 'Palazzo',
        resultLabel: 'Palazzi',
        search: 'palazzo',
      },
    ],
  },
  {
    value: PropertyTypeGroupValues.COMMERCIALE,
    label: 'Immobile o attività commerciale',
    resultLabel: 'Imm. e att. commerciali',
    propertyTypes: [
      {
        value: CommercialePropertyTypes.ATTIVITA_LICENZA_COMMERCIALE,
        label: 'Attività/Licenza commerciale',
        resultLabel: 'Attività/licenze commerciali',
        search: 'attività/licenza comm',
      },
      {
        value: CommercialePropertyTypes.NEGOZIO_LOCALE_COMMERCIALE,
        label: 'Negozio/Locale commerciale',
        resultLabel: 'Negozi/locali commerciali',
        search: 'negozio/locale comm',
      },
    ],
  },
  {
    value: PropertyTypeGroupValues.TERRENO,
    label: 'Terreno',
    resultLabel: 'Terreni',
    propertyTypes: [
      {
        value: TerrenoPropertyTypes.EDIFICABILE,
        label: 'Terreno edificabile',
        resultLabel: 'Terreni edificabili',
        search: 'terreno edificabile',
      },
      {
        value: TerrenoPropertyTypes.AGRICOLO,
        label: 'Terreno agricolo',
        resultLabel: 'Terreni agricoli',
        search: 'terreno agricolo',
      },
    ],
  },
  {
    value: PropertyTypeGroupValues.GARAGE_POSTO_AUTO,
    label: 'Garage o posto auto',
    resultLabel: 'Garage e posti auto',
    propertyTypes: [
      {
        value: GaragePropertyTypes.GARAGE_POSTO_AUTO,
        label: 'Garage o posto auto',
        resultLabel: 'Garage e posti auto',
        search: '',
      },
    ],
  },
  {
    value: PropertyTypeGroupValues.STANZA,
    label: 'Stanza singola',
    resultLabel: 'Stanze',
    propertyTypes: [
      {
        value: StanzaPropertyTypes.STANZA,
        label: 'Stanza',
        resultLabel: 'Stanze',
        search: '',
      },
    ],
  },
  {
    value: PropertyTypeGroupValues.CANTINA_SOLAIO,
    label: 'Cantina o solaio',
    resultLabel: 'Cantine e solai',
    propertyTypes: [
      {
        value: CantinaPropertyTypes.CANTINA_SOLAIO,
        label: 'Cantina o solaio',
        resultLabel: 'Cantine e solai',
        search: '',
      },
    ],
  },
];
